<app-multi-select-with-static-options
  [formControl]="control"
  [label]="label"
  [inline]="inline"
  [name]="name"
  [errorMessages]="errorMessages"
  [small]="small"
  [multi]="multi"
  [prefix]="prefix"
  [placeholder]="placeholder"
  [sortByDisplayValue]="false"
  [selectOptions]="selectOptions"
></app-multi-select-with-static-options>

